'use client';

import dynamic from 'next/dynamic';

const ContainerQueriesDemo = dynamic(() => import('./index'));

export default ContainerQueriesDemo;
